import NotFoundPage from "@/pages/NotFoundPage";
import { ConfigProvider } from "antd";
import { Outlet, Route, Routes } from "react-router-dom";
import "@/projects/IPO/styles/style.css";
import routes from "./utils/routes";

const NewsApp = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];

  return (
    <ConfigProvider
      theme={{
        hashed: false,
      }}
      componentSize="large"
    >
      <div className="news-app" style={{ height: "48px" }}>
        <Routes>
          <Route element={<Outlet />}>
            {publicRoutes.map(({ path, element: Page }) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
};

export default NewsApp;
